import * as angular from 'angular';
import {IController} from "angular";
import {PackingInfoStatusType} from "../../types/packing-info-status.type";

export class DeliveryPackagesInfoCtrl implements IController {
  packageList: any;
  isPacked: any;
  packingInfo: any;
  packedDate: any;
  hasMissingPackages: boolean;

  public packingInfoStatusType: typeof PackingInfoStatusType = PackingInfoStatusType;
  public packingDisplayStatus: string;

  $onInit() {
    this._setDisplayStatus();
  }

  private _setDisplayStatus() {
    this.packingDisplayStatus = this.packingInfo?.status ||
      (this.isPacked ? this.packingInfoStatusType.Packed : this.packingInfoStatusType.NotPacked);
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryPackagesInfo', {
    bindings: {
      packageList: '<',
      hasMissingPackages: '<',
      isPacked: '<',
      packedDate: '<',
      packingInfo: '<?'
    },
    template: require('./delivery-packages-info.html').default,
    controller: DeliveryPackagesInfoCtrl
  });
